import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import { isEmpty, map } from "lodash"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { addBrokerResource, getBrokerResource } from "../../store/actions"
import OfficeSidebar from "components/VerticalLayout/OfficeSidebar";
import {
    Row,
    Col,
    CardBody,
    Card,
    CardText,
    Container,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    FormGroup,
    Label,
    Input,
    Button,
    Select
} from "reactstrap"
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import OfficeMenu from "./office-menu";

class OurResource extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fileName: '',
      selectedImage: '',
      fname: ''
    }
    this.onFileChange = this.onFileChange.bind(this);
    this.handleResourceSubmit = this.handleResourceSubmit.bind(this)
  }
  onFileChange(e) {
    let files = e.target.files;
    let fileNames = files[0];
    let fname = fileNames['name'];
    
    let fileReader = new FileReader();
    fileReader.readAsDataURL(files[0]);
    
    fileReader.onload = (event) => {
      
      this.setState({
        selectedImage: event.target.result,
       }),
       this.setState({
        fname: fname,
       })
       

    }
  }
  handleResourceSubmit(value){
    this.props.addBrokerResource(value, this.props.history);
  }
  componentDidMount() {
    const { onGetBrokerResource } = this.props;
    onGetBrokerResource(localStorage.getItem('brokerId'));
}
  render() {
    const { resources } = this.props;
    return (
      <React.Fragment>
          <ToastContainer autoClose={2000} />
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Resource | Realty Space</title>
          </MetaTags>
          <Container fluid className="">
          <Row>
             
              <Col sm='12' className="">
              <Row className="project-header">
                <Breadcrumbs
                title={this.props.t("Office")}
                breadcrumbItem={this.props.t("Resource")}
                />
            
            </Row>
            <OfficeMenu />
        
                            <Row>
				<Col sm="12">
					 <Card className="border-full"> 
                    <CardBody>
                    <h5 className="card-title">Resource History</h5>
					<div className="table-responsive">
         
              <DataTable className="" stripedRows value={resources} paginator rows={10} rowsPerPageOptions={[10, 20, 30, 50, 100, 150, 200, 500 ]} currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries " paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown   " tableStyle={{ minWidth: '50rem' }}   >
             <Column
                header="#"
                body={(rowData, options) => options.rowIndex + 1}
                style={{ width: '60px' }}
              />

              <Column  field="resourceTitle" header="Title"></Column>
              <Column  field="eventDescription" header="Link" body={(rowData) => (
                  <a target="_blank" rel="noreferrer" href={"http://realtyspace-001-site2.itempurl.com/" + rowData.resourceUrl}>View</a>
              )}></Column>
          </DataTable>
						</div>
					</CardBody>
					</Card>
				</Col>
			</Row> 
      </Col>
      </Row>
           
           
           
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
OurResource.propTypes = {
  t: PropTypes.any,
  match:PropTypes.object,
  history: PropTypes.object,
  addBrokerResource: PropTypes.func,
  onGetBrokerResource:PropTypes.func,
  resources:PropTypes.array
}
const mapStateToProps = ({ Resource }) => (
  {
    resources: Resource.resources

  })

  const mapDispatchToProps = dispatch => ({
   
    addBrokerResource: (data) => dispatch(addBrokerResource(data)),
    onGetBrokerResource:(BrokerId) => dispatch(getBrokerResource(BrokerId))
   
  });
export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(OurResource))
